<template>
  <b-modal
    id="payment-modal"
    class="payment-modal"
    cancel-variant="outline-danger"
    ok-title="Send"
    size="lg"
    hide-header
    centered
    @show="getCustomers"
    @hidden="clear"
    @ok="handleOK"
    :ok-disabled="okDisabled"
  >
    <form @submit.stop.prevent="handleSubmit">
      <b-form-group label="Customer" label-for="customer" class="h-form-group">
        <model-select
          id="customer"
          v-model="customer"
          :options="customers"
          placeholder="Select a customer"
          @input="customerInput($event)"
        />
      </b-form-group>
      <b-form-group
        v-if="showAccounts"
        label="Account"
        label-for="account"
        class="h-form-group"
      >
        <model-select
          id="account"
          v-model="account"
          :options="accounts"
          placeholder="Select an account"
          @input="accountInput($event)"
        />
      </b-form-group>
      <b-form-group label="Amount" label-for="amount" class="h-form-group">
        <currency-input id="amount" v-model="amount" />
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import endpoints from '@/utils/endpoints.js'

export default {
  components: {
    ModelSelect
  },
  data() {
    return {
      customer: { value: {}, text: '' },
      customers: [],
      account: { value: {}, text: '' },
      accounts: [],
      showAccounts: false,
      amount: 0
    }
  },
  computed: {
    okDisabled() {
      const ready =
        this.customer?.value && this.account?.value && this.amount > 0
      return !ready
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant
    }
  },
  methods: {
    clear() {
      this.customer = { value: {}, text: '' }
      this.customers = []
      this.account = { value: {}, text: '' }
      this.accounts = []
      this.showAccounts = false
      this.amount = 0
    },
    getCustomers() {
      new Promise((resolve, reject) => {
        setTimeout(() => {
          this.axios
            .get(endpoints.listCustomers(this.currentMerchant.id), {
              params: { page: 1, page_size: 10000 }
            })
            .then(res => {
              let results = []
              for (const customer of res.data.results) {
                const name = customer.first_name + ' ' + customer.last_name
                results.push({ value: customer, text: name })
              }

              resolve(results)
            })
            .catch(err => {
              console.log('error', err)
              reject(err)
            })
        }, 100)
      }).then(response => {
        this.customers = response
      })
    },
    customerInput(event) {
      // Nuke an existing choice if they change the customer.
      if (this.account.value) {
        this.account = {}
      }

      // Build the list of accounts choices for the customer, if selected.
      if (this.customer.value) {
        let results = []
        for (const account of this.customer.value.accounts) {
          const name = account.id
          results.push({ value: account, text: name })
        }

        // Don't show the search if there's only one, and just pick it.
        this.showAccounts = results.length > 1
        if (results.length == 1) {
          this.account = results[0]
          this.amount = this.$ci.parse(results[0].value.amount_due)
          console.log(this.customer.value, this.account.value, this.amount)
        }

        this.accounts = results
      }
    },
    accountInput(event) {
      if (this.account.value) {
        this.amount = this.$ci.parse(this.account.value.amount_due)
      }
    },
    handleOK() {
      const merchantID = this.currentMerchant.id
      const accountID = this.account.value.id

      const date = new Date().toISOString().split('T')[0]
      const payload = {
        amount_due: this.amount,
        minimum_payment: this.amount,
        maximum_payment: this.amount,
        due_date: date
      }

      this.axios
        .patch(endpoints.partialUpdateAccount(merchantID, accountID), payload)
        .then(res => {
          this.$toasted.show('Request sent!', {
            duration: 2000,
            position: 'bottom-right'
          })

          return this.axios.post(
            endpoints.sendMessageAccount(merchantID, accountID)
          )
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
